import { css, type CSSObject } from '@emotion/react'
import {
  ColorPrimitives,
  FOCUS_RING_WIDTH,
  gemVar,
  Size,
  Spacing,
  ThemedColors,
  Transition,
  Typography,
  ZIndex,
} from '@opallabs/gem'

// The size of the pending badge, used for both its block and inline dimensions.
const PENDING_BADGE_SIZE = 16

export const notificationFooter = css({
  alignItems: 'center',
  display: 'flex',
  paddingBlock: Spacing.XS,
  gap: Spacing.S,
  justifyContent: 'space-between',
})

export const sendState = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
})

export const pendingCount = css({
  color: gemVar(ThemedColors.TextWarning),
  whiteSpace: 'nowrap',
})

export const notified = css({
  whiteSpace: 'nowrap',
})

export const modeOption = css({
  '&[aria-checked=true]': {
    backgroundColor: gemVar(ThemedColors.Primary4),
  },
})

export const modeOptionIcon = css({
  alignSelf: 'flex-start',
  marginBlockStart:
    Spacing.XS + (Typography.T500.fontSize * 1.5 - Size.Icon) / 2,
  marginInlineEnd: Spacing.S,
})

export const modeOptionText = css({
  display: 'flex',
  flexDirection: 'column',
  paddingBlock: Spacing.XS,
})

export const modeOptionLabel = css({
  fontWeight: 600,
})

export const modeOptionDescription = css({
  color: gemVar(ThemedColors.TextSecondary),
})

export const pendingBadge = css({
  ...Typography.T300,
  alignItems: 'center',
  backgroundColor: gemVar(ColorPrimitives.A100),
  blockSize: PENDING_BADGE_SIZE,
  borderRadius: PENDING_BADGE_SIZE / 2,
  boxSizing: 'border-box',
  color: gemVar(ColorPrimitives.A600),
  display: 'inline-flex',
  justifyContent: 'center',
  lineHeight: 1,
  minInlineSize: PENDING_BADGE_SIZE,
  paddingInline: Spacing.XS,
})

// The picker menu is on the Shroud popover layer. This modal must be above it.
export const disableNotificationsOverlay: CSSObject = {
  zIndex: ZIndex.Shroud.Popover + 1,
}

export const disableNotificationsModal = css({
  zIndex: ZIndex.Shroud.Popover + 2,
})

export const toolbarCollapse = css({
  display: 'grid',
  gridTemplateColumns: '0fr',
  marginInlineStart: -Spacing.S,
  opacity: 0,

  '&[data-open="true"]': {
    gridTemplateColumns: '1fr',
    marginInlineStart: 0,
    opacity: 1,
  },

  ...Transition(['gridTemplateColumns', 'marginInlineStart', 'opacity'], {
    duration: 100,
  }),
})

export const toolbarCollapseContent = css({
  columnGap: Spacing.S,
  display: 'flex',
  margin: -FOCUS_RING_WIDTH,
  overflow: 'hidden',
  padding: FOCUS_RING_WIDTH,
})
